'use client';

import React from 'react';
import { Upload, Clock, Coins, TrendingUp, Rocket, Wallet } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const STEPS = [
  {
    icon: Upload,
    title: 'Artists Upload Snippets',
    color: 'var(--secondary)',
    bg: 'rgba(42,157,143,0.1)',
  },
  {
    icon: Clock,
    title: 'Anticipation Phase Begins',
    color: '#C084FC',
    bg: 'rgba(168,85,247,0.1)',
  },
  {
    icon: Coins,
    title: 'MCTs Are Issued',
    color: '#EC4899',
    bg: 'rgba(236,72,153,0.1)',
  },
  {
    icon: TrendingUp,
    title: 'Momentum Phase Activates',
    color: 'var(--secondary)',
    bg: 'rgba(42,157,143,0.1)',
  },
  {
    icon: Rocket,
    title: 'Momentum Score Evolves',
    color: 'var(--positive)',
    bg: 'rgba(16,185,129,0.1)',
  },
  {
    icon: Wallet,
    title: 'Fans Buy & Sell MCTs',
    color: 'var(--primary)',
    bg: 'rgba(168,85,247,0.1)',
  },
];

export default function HowItWorksSection() {
  return (
    <section className="py-20 sm:py-28 px-4 sm:px-6 lg:px-10">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            How <span className="gradient-text-cyan">EchoMint</span> Works
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {STEPS?.map((step, i) => {
            const Icon = step?.icon;
            return (
              <div key={`step-${i}`} className="glass-card rounded-2xl p-6 card-hover flex items-center gap-4">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ background: step?.bg }}
                >
                  <Icon size={22} style={{ color: step?.color }} />
                </div>
                <div className="flex items-center gap-3">
                  <span
                    className="text-2xl font-bold tabular-nums"
                    style={{ color: 'var(--border)' }}
                  >
                    {i + 1}
                  </span>
                  <h3 className="font-semibold text-sm leading-snug">{step?.title}</h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}